<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          cols="12"
          md="12"
        >
          <product-config-title />
        </b-col>
        <b-col
          cols="12"
          md="12"
        >
          <product-config-summary />
        </b-col>
        <b-col
          cols="12"
          md="12"
        >
          <product-config-content />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol,
} from 'bootstrap-vue'
import ProductConfigTitle from '@/views/Admin/Defines/Product_config/Elements/TitleCard.vue'
import ProductConfigSummary from '@/views/Admin/Defines/Product_config/Elements/SummaryCard.vue'
import ProductConfigContent from '@/views/Admin/Defines/Product_config/Elements/ContentCard.vue'

export default {
  name: 'ProductConfigItemForm',
  components: {
    ProductConfigContent,
    ProductConfigSummary,
    ProductConfigTitle,
    BCard,
    BRow,
    BCol,
  },
  computed: {
    itemData() {
      return this.$store.getters['productConfig/dataItem']
    },
  },
}
</script>
